import { lighten } from 'polished'
import styled from 'styled-components'

const colorDanger: string = '#d24444'

export const LineTd = styled.td<{
  error?: boolean
  numberCell?: boolean
}>`
  padding: 0;
  vertical-align: middle;
  text-align: ${({ numberCell }) => (numberCell ? 'right' : 'inherit')};
  background-color: ${({ error }) =>
    error ? lighten(0.3, colorDanger) : 'inherit'};
`

export const TdInput = styled.input<{
  error?: boolean
  numberInput?: boolean
}>`
  border: 0;
  height: 100%;
  overflow: initial;
  width: ${({ numberInput }) => (numberInput ? '4em' : '100%')};
  text-align: ${({ numberInput }) => (numberInput ? 'right' : 'inherit')};
  background-color: ${({ error }) =>
    error ? lighten(0.3, colorDanger) : 'transparent'};
`

export const DeleteButton = styled.button`
  background-color: transparent;
  border: 0;
  color: ${colorDanger};
  cursor: pointer;
`

export const TdSelect = styled.select<{
  error?: boolean
}>`
  color: ${({ error }) => (error ? lighten(0.3, colorDanger) : 'initial')};
  border-color: ${({ error }) =>
    error ? lighten(0.3, colorDanger) : 'initial'};
`
